// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../../shared/action-creators/busy-counter';
import {getRgaStatus, getRgaUnits} from '../../services/fetch-service-rga';
import actions from '../../../actions-list';

export const getRgaUnitsDropDown = () =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const rgaUnits = await getRgaUnits();

            dispatch({
                rgaUnits,
                type: actions.UPDATE_RGA_UNIT_DROPDOWN
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const getRgaStatusDropDown = () =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const rgaRecallStatus = await getRgaStatus();

            dispatch({
                rgaRecallStatus,
                type: actions.UPDATE_RGA_STATUS_DROPDOWN
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const getRgaRequestorTypeDropDown = query => ({
    query,
    type: actions.UPDATE_RGA_REQUESTOR_TYPE_DROPDOWN
});

export const getRgaAnalysisStatusDropDown = query => ({
    query,
    type: actions.UPDATE_RGA_ANALYSIS_STATUS_DROPDOWN
});



// WEBPACK FOOTER //
// ./src/rga/shared/rga-domain-values/action-creators/rga-domain-values.js